/** Every fan-facing string the Survivor Game tab renders (ISSUE-973). Plain American English, sentence case, no dashes. */

export const SURVIVOR_ROUNDS_LABEL = "Rounds";
export const SURVIVOR_MY_PICKS_HEADING = "My picks";
export const SURVIVOR_MATCHES_HEADING = "Matches";
export const SURVIVOR_PICK_LABEL = "Pick";
export const SURVIVOR_PICKED_LABEL = "Picked";
export const SURVIVOR_PRIORITY_LABEL = "Priority";
export const SURVIVOR_STATUS_LABEL = "Status";
export const SURVIVOR_SUBMITTED_LABEL = "Submitted";
export const SURVIVOR_LOCK_LABEL = "Lock";
export const SURVIVOR_STATUS_IN = "In";
export const SURVIVOR_STATUS_REVIVED = "Revived";
export const SURVIVOR_STATUS_ELIMINATED = "Eliminated";
export const SURVIVOR_STATUS_NOT_PLAYING = "Not playing";
export const SURVIVOR_LOCKED_VALUE = "Locked";
export const SURVIVOR_UNDER_A_MINUTE = "Under a minute";
export const SURVIVOR_MISSED_PICK_NOTE =
  "Picks you haven't made by the lock count as losses.";
export const SURVIVOR_ROUND_FULL_NOTE =
  "You've made all your picks for this round. Remove one to pick another.";
export const SURVIVOR_OUTCOME_WON = "Won";
export const SURVIVOR_OUTCOME_LOST = "Lost";
export const SURVIVOR_OUTCOME_TIE = "Tie";
export const SURVIVOR_OUTCOME_PENDING = "Pending";
export const SURVIVOR_OUTCOME_NOT_SAVED = "Not saved yet";
export const SURVIVOR_GAME_LIVE = "Live";
export const SURVIVOR_GAME_FINAL = "Final";
export const SURVIVOR_GAME_POSTPONED = "Postponed";
export const SURVIVOR_GAME_CANCELED = "Canceled";
export const SURVIVOR_GAME_DELAYED = "Delayed";
export const SURVIVOR_GAME_NOT_FINAL = "Not final";
export const SURVIVOR_ADD_ENTRY_LABEL = "Add another entry";
export const SURVIVOR_ADDING_ENTRY_LABEL = "Adding another entry";

export function survivorRoundLabel(ordinal: number): string {
  return `Round ${ordinal}`;
}
export function survivorFromNowLabel(
  count: number,
  unit: "minute" | "hour" | "day",
): string {
  return count === 1
    ? `${count} ${unit} from now`
    : `${count} ${unit}s from now`;
}
export function survivorVersusLabel(opponentName: string): string {
  return `vs ${opponentName}`;
}
export function survivorRemoveLabel(teamName: string): string {
  return `Remove ${teamName}`;
}
export function survivorMoveLabel(teamName: string, priority: number): string {
  return `Move ${teamName} to priority ${priority}`;
}

// ISSUE-1044. Skip this round (SUR-R87): the control, its confirm, and the
// note for each refusal the server can send back.
export const SURVIVOR_SKIP_ROUND_LABEL = "Skip this round";
export const SURVIVOR_UNDO_SKIP_LABEL = "Undo skip";
export const SURVIVOR_SKIP_CONFIRM_TITLE = "Skip this round?";
export const SURVIVOR_SKIP_CONFIRM_LABEL = "Skip this round";
export const SURVIVOR_SKIP_CANCEL_LABEL = "Cancel";
export const SURVIVOR_SKIPS_UNLIMITED = "Unlimited skips";
export const SURVIVOR_SKIPS_NONE_LEFT = "No skips left";
export const SURVIVOR_SKIP_ROUND_LOCKED_NOTE =
  "This round locked before your skip went through.";
export const SURVIVOR_SKIP_HAS_PICKS_NOTE =
  "You already have a pick in this round, so it can't be skipped. We refreshed it for you.";
export const SURVIVOR_SKIP_NONE_LEFT_NOTE =
  "You have no skips left in this contest.";
export const SURVIVOR_UNDO_ROUND_LOCKED_NOTE =
  "This round has locked, so your skip stands.";
export const SURVIVOR_UNDO_NOT_FOUND_NOTE =
  "That skip was already taken back. We refreshed the round for you.";

export function survivorSkipsLeftLabel(skipsRemaining: number | null): string {
  if (skipsRemaining === null) return SURVIVOR_SKIPS_UNLIMITED;
  if (skipsRemaining <= 0) return SURVIVOR_SKIPS_NONE_LEFT;
  if (skipsRemaining === 1) return "1 skip left";
  return `${skipsRemaining} skips left`;
}
export function survivorSkipConfirmBody(skipsRemaining: number | null): string {
  const opening =
    "You'll sit this round out. You survive it, score nothing for it, and keep your streak.";
  const closing = " You can undo it until the round locks.";
  if (skipsRemaining === null) {
    return `${opening} Your pool has no limit on skips.${closing}`;
  }
  if (skipsRemaining === 1) {
    return `${opening} This uses your last skip.${closing}`;
  }
  return `${opening} This uses 1 of your ${skipsRemaining} skips left.${closing}`;
}

/** ISSUE-1331. The Game tab's contest menu and its look-back notes. */
export const SURVIVOR_CONTEST_MENU_LABEL = "Contest";
export const SURVIVOR_CONTEST_MENU_PLACEHOLDER = "Look back at a contest";
export function survivorLookBackNote(contestName: string): string {
  return `You're looking back at ${contestName}. These picks can't be changed.`;
}
export function survivorLookBackNoEntryNote(contestName: string): string {
  return `You didn't play in ${contestName}. Everyone's picks are on the Results tab.`;
}
